import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json', // Nagłówek Content-Type dla JSON
  },
});

// Dodaj token do każdego żądania, jeśli istnieje w localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token'); // Pobiera token z localStorage
  if (token) {
    config.headers.Authorization = `Bearer ${token}`; // Dodaje nagłówek Authorization
  }
  return config;
}, (error) => {
  return Promise.reject(error); // Obsługuje błędy w konfiguracji
});

export default api;
